import { OnsiteInterviewAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { IGetOnsiteInterviewStatusCountPayload } from '../types';
import { TGetOnsiteInterviewStatusCountResult } from '../types/OnsiteInterview';

export const getOnsiteInterviewStatusCount = async (
  payload: IGetOnsiteInterviewStatusCountPayload,
): Promise<TGetOnsiteInterviewStatusCountResult> => {
  const response = await PermanentJobsApi.getOnsiteInterviewStatusCount(payload);

  return OnsiteInterviewAdapters.toGetOnsiteInterviewStatusCountResult(response);
};
